import {
  FETCH_CODE_REFS_BEGIN,
  FETCH_CODE_REFS_SUCCESS,
  FETCH_CODE_REFS_FAILURE,
} from "../actions/actionTypes";

const levelOptions = [
  { key: 0, text: "CONCERN", value: "CONCERN" },
  { key: 1, text: "UNACCEPTABLE", value: "UNACCEPTABLE" },
];

const initialState = {
  level: levelOptions[0].value,
  description: "",
  codeRefs: [],
  codeRefOptCounter: 0,
  codeRefOptions: [],
  loading: false,
  error: null,
  title: "",
};

const comment = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CODE_REFS_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_CODE_REFS_SUCCESS:
      return {
        ...state,
        loading: false,
        codeRefOptions: action.payload.codeRefs,
      };
    case FETCH_CODE_REFS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        codeRefOptions: [],
      };
    default:
      return state;
  }
};

export default comment;
